
function BS(target) {
  
  target.each(function(){
    
    var t = $(this)
    
     if(t.hasClass('sw')){
        var a =t.width()/t.attr('data-aspect')  
        t.height(a);
        if(t.find('.cell .imgFix').size()>0){
          var z = t.width()-40,
              y = a-40
          t.find('img').css('max-height',y);
          t.find('img').css('max-width',z);
        }  
      }
    
    //fadeInBS
    if(t.hasClass('fadeInBS')){
    if(t.css('visibility','visible') && !t.hasClass('ni') && t.hasClass('ON')){
      if (t.attr('data-img-mob') && $(window).width()<780){
        var d = t.attr('data-img-mob')  
      }else{
        var d = t.attr('data-img')
      }
      t.backstretch(d);
    }
    }else{
      if(!t.hasClass('ni')){
         if (t.attr('data-img-mob') && $(window).width()<780){
           var d = t.attr('data-img-mob')  
         }else{
           var d = t.attr('data-img')
         }
         t.backstretch(d);
       }
    }
             
    
    
    
    
  });
}





$(document).ready(function(){

  BS($('.bs'))

  
  
  
    //cookie
 if (!$.cookie('timeOutCookie#1')) {
   
   
        var timeout = 3000
        var pop = $('#newsletter')
    
   
   
   
   setTimeout(function(){
    $('.popOut').fadeIn(400,function(){  
     
    
       pop.show()
       setTimeout(function(){pop.addClass('ON')},400)
  
    $.cookie('timeOutCookie#1', true, { expires: 30, path: '/' })
    })
   },timeout)
}
  
  
  
    //form Send
   $('.mailSend').click(function(event){
     
   event.preventDefault();
    var t = $(this), 
        a = t.parents('form'),
        b = a.find('input')
       
   
       a.validate();
        if (a.valid())
        {
          t.addClass('ON').val("Sending")
          setTimeout(function(){
           t.val("Thanks!")
          a.submit()
          },2500)
          
        }
        else 
        {
       
           t.addClass('ON').val("Please complete all fields")
        setTimeout(function(){
          t.removeClass('ON').val("Submit")
        },2500)
        }
 
   });
  
  

  
      //product drop down
$(".fdrop").on("click", ".init", function() {
    $(this).closest(".fdrop").children('li:not(.init)').show();
});

  
    
var allOptions = $(".fdrop").children('li:not(.init)');
$(".fdrop").on("click", "li:not(.init)", function() {
    var a = $(this).attr('data-varid'),
        b = $('.varIDhold')
    allOptions.removeClass('selected');
    $(this).addClass('selected');
    $(".fdrop").children('.init').html($(this).html());
    allOptions.hide();
    b.val(a)
});
  
  
  
  //PopOuts open
  $(document).on('click', '.hasPop', function(event){ 
 
    event.preventDefault()
    var t = $(this),
        a = t.attr('data-getPop'),
        a = $('#'+a),
        b = $('.popOut'),
        c = $('body')
       
    if(t.hasClass('expandMe')){
    $('.artWrapper').empty()  
    t.parents('article').find('.copy').clone().appendTo( ".artWrapper" );
    }
    
    if($('.popOut').hasClass('ON')){
    $('.popOut .ON').removeClass('ON');
    setTimeout(function(){
    $('.popOut .inner').hide()
    a.show()
    },400)
    setTimeout(function(){
    a.addClass('ON')
    },600)
    }else{
   
    b.fadeIn(200);a.show();c.css('overflow-y','hidden');
    setTimeout(function(){
    a.addClass('ON') ; b.addClass('ON')
    },400)
    }
    
  });
  
  $('.popOut .clsBox').click(function(event){
    event.preventDefault()
    var c = $('body')
    $('.popOut .inner.ON').removeClass('ON')
    setTimeout(function(){
    $('.popOut .inner').hide();$('.popOut').fadeOut(400).removeClass('ON');c.css('overflow-y','auto');
    },400)
  });
  
  
  
  
  //mob stuff
  
   $('.mobImages').cycle({
  timeout:0,
  slides:"> img",
  swipe:true,
     fx:"scrollHorz"
    });
  
  
  
   //mob menu
  $('.mobMenuButton').click(function(event){
  event.preventDefault()
  var t = $(this),
      mbm = $('.mobPopOut'),
      bdy = $('body'),
      grid = $('.grid')
  if(t.hasClass('ON')){
  bdy.css('overflow-y','auto');mbm.fadeOut(200);t.removeClass('ON');grid.show()
  }else{
   bdy.css('overflow-y','hidden');mbm.fadeIn(200);t.addClass('ON');grid.hide()
  }
  });
  
  
     
  //home Sliders
 $('.homeSlider ul').cycle({pauseOnHover:true,fx: 'scrollHorz', timeout:4000,slides:"> li",pager:".homeSlider .pager"})
  
  
  
  $('.homeOwl ul').each(function(){
    var t = $(this),
        a = t.closest('.homeOwl').find('.carNext'),
        b = t.closest('.homeOwl').find('.carPrev')
       
    t.owlCarousel({
      autoPlay:0,
      stopOnHover:true,
      slideSpeed:700,
      responsive : {
        0 : {items:1},
        560 : {items:2},
        780 : {items:2},
        960 : {items:3},
        1200 : {items:3}
      },
     
    });
    var owl = t.data('owlCarousel')
    a.click(function(){owl.next()})
    b.click(function(){owl.prev()})
  });

     

  
  });//ready


$(window).resize(function(){
  
  BS($('.bs'))

  
});//resize


$(window).scroll(function() {
  
  
  //pop down header
    var a = $('.wEffect')
  
  if ($(this).scrollTop() > 100) { 
    a.addClass('onScroll') 
    }else{
    a.removeClass('onScroll')
    }


  

});//scroll